/* Qalbeen · HOVER · bloc « Offre » de la fiche produit (snippets/hover-offre.liquid).
   Choix 1 « <Nom> + Qalbeen+ » :
     - « 30 jours offerts » : le produit (propriété _hv_offre) + l'app au mois du panier HOVER (_hv_cadeau = app30) ;
     - « À l'année » : le produit + l'app 1 an (plan) + cfg.nf1 formules thérapie choisies : les cfg.nf premières offertes avec
       l'année (_hv_offre = formule-an), la suivante = formule du palier 40 € du panier (_hv_cadeau = formule40).
     L'interrupteur [data-hvo-m1] est sur la ligne de l'app (.hvo-appl).
     Le panier HOVER (assets/hover-cart.js) ajoute ensuite les cadeaux des paliers et pose les codes cachés.
   Version digitale (affichée en premier) : l'app à l'année (+ cfg.nf formules) ou au mois.
   Formules offertes : bouton [data-hvo-fpick] qui ouvre la fenêtre des formules (assets/hover-offre-formules.js, cfg.nf choix) ;
   le choix est gardé dans le champ caché [data-hvo-formule] (handles séparés par des virgules, le même dans les deux choix).
   Suit la variante choisie sur la fiche (évènement « hvp:variant » de hover-product.js).
   Les ajouts portent l'en-tête X-HPN (le panier ne les intercepte pas), puis le panier HOVER se synchronise et s'ouvre. Sans jQuery. */
(function () {
  if (window.HoverOffre) return;
  var D = document;
  var $ = function (s, c) { return (c || D).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };
  var R = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var H = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-HPN': '1' };
  function api(path, body) {
    return fetch(R + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: H, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || 'panier'); return j; }); });
  }
  /* même écriture que le filtre money de Shopify, déduite de l'exemple 1234,56 rendu par Liquid */
  function moneyFn(sample) {
    var m = String(sample || '').match(/^(.*?)1([^0-9]?)234(?:([^0-9])56)?(.*)$/);
    return function (c) {
      c = Math.round(c);
      if (!m) return (c / 100).toFixed(2);
      var e = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
      return m[1] + e + (m[3] ? m[3] + ('0' + (c % 100)).slice(-2) : '') + m[4];
    };
  }
  /* ajoute les formules choisies (handles) ; props = propriétés de la ligne (formule-an, ou formule40 pour la formule du palier) */
  function formules(handles, items, props) {
    return Promise.all(handles.map(function (handle) {
      return fetch(R + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('formule'); return r.json(); })
        .then(function (p) { var fv = (p.variants || []).filter(function (x) { return x.available; })[0]; if (!fv) throw new Error('formule'); return fv.id; });
    })).then(function (ids) { ids.forEach(function (id) { items.push({ id: id, quantity: 1, properties: props || { _hv_offre: 'formule-an' } }); }); });
  }
  function liste(v) { return String(v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  /* Depuis le 22/10/2026 : plus de code caché, les formules offertes avec l'app 1 an (_hv_offre) sont rendues gratuites par la
     fonction de remise « Cadeaux Qalbeen » (app-com/). */
  function poserCode(code) {
    if (code) return Promise.resolve();
    return api('cart.js').then(function (c) {
      var act = (c.discount_codes || []).map(function (d) { return d.code; });
      if (act.some(function (x) { return x.toUpperCase() === code.toUpperCase(); })) return;
      return api('cart/update.js', { discount: act.concat(code).join(',') });
    });
  }
  function ouvrirPanier() { if (window.HVCart && HVCart.refresh) HVCart.refresh(true); else window.location.href = R + 'cart'; }

  function bloc(el) {
    if (el._hvo) return; el._hvo = 1;
    var cfg; try { cfg = JSON.parse($('[data-hvo-cfg]', el).textContent); } catch (e) { return; }
    var money = moneyFn(cfg.money);
    var sec = el.closest('[data-hvp]') || D;
    var st = { opt: cfg.defaut, m1: '30', m2: cfg.mode2 || 'mois' };
    if (!cfg.app30 && cfg.an) st.m1 = 'an';
    var cta = $('[data-hvo-cta]', el), ctaP = $('[data-hvo-ctaprice]', el), err = $('[data-hvo-err]', el), ferr = $('[data-hvo-ferr]', el);
    var J = cfg.jeu;
    (cfg.variantes || []).forEach(function (x) { if (x.id === J.id) J = { id: x.id, c: x.c, p: x.p, s: x.s, pan: x.pan, a: x.a }; });

    var NF = +cfg.nf || 1, NF1 = +cfg.nf1 || NF; /* NF1 : choix 1 à l'année (formules de l'année + celle du palier) */
    function maxDe(opt) { return opt === 'jeu' ? NF1 : NF; }
    function sel(opt) { var o = $('[data-hvo-opt="' + opt + '"]', el); return o && $('[data-hvo-formule]', o); }
    /* formules choisies dans la fenêtre : chaque offre garde son choix (3 avec le produit à l'année, 2 avec la version digitale) */
    function poserFormule(fs, opt) {
      fs = [].concat(fs);
      var o = $('[data-hvo-opt="' + (opt || st.opt) + '"]', el) || el;
      $$('[data-hvo-formule]', o).forEach(function (i) { i.value = fs.map(function (f) { return f.handle; }).join(','); });
      $$('[data-hvo-flabel]', o).forEach(function (l) { l.textContent = fs.map(function (f) { return String(f.nom || '').split(' · ')[0]; }).join(' + '); });
      $$('[data-hvo-fchange]', o).forEach(function (c) { c.textContent = c.getAttribute('data-changer') || ''; });
      if (ferr) ferr.hidden = true; $$('[data-hvo-ferr2]', el).forEach(function (x) { x.hidden = true; });
    }
    function choisirFormule(apres, opt) {
      opt = opt || st.opt;
      var i = sel(opt) || $('[data-hvo-formule]', el), mx = maxDe(opt);
      if (!window.HVFormules || !HVFormules.open({ mode: 'choisir', max: mx, current: mx > 1 ? liste(i && i.value) : (i ? i.value : ''), onPick: function (f) { poserFormule(f, opt); if (apres) apres(); } })) return false;
      return true;
    }
    function prix() {
      if (st.opt === 'jeu') return st.m1 === 'an' ? J.pan : J.p;
      return (cfg[st.m2] || cfg.mois).p;
    }
    function rendre() {
      $$('[data-hvo-opt]', el).forEach(function (o) {
        var on = o.getAttribute('data-hvo-opt') === st.opt; o.classList.toggle('on', on);
        var r = $('input[type=radio]', o); if (r) r.checked = on;
      });
      /* choix 1 : 30 jours ou année */
      $$('[data-hvo-m1]', el).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hvo-m1') === st.m1)); });
      $$('[data-hvo-show]', el).forEach(function (li) { li.hidden = li.getAttribute('data-hvo-show') !== st.m1; });
      /* cadeaux des paliers : montant que le panier comptera (l'app 30 jours y est à 0 €, l'app 1 an compte) */
      var base = J.c + (st.m1 === 'an' && cfg.an ? cfg.an.c : 0);
      $$('[data-hvo-min]', el).forEach(function (li) { var sh = li.getAttribute('data-hvo-show'); li.hidden = (sh && sh !== st.m1) || base < (+li.getAttribute('data-hvo-min') || 0); });
      var l1 = $('.hvo-appl', el); if (l1 && l1.hasAttribute('data-hvo-val30')) { if (st.m1 === '30') l1.setAttribute('data-hvo-val', l1.getAttribute('data-hvo-val30')); else l1.removeAttribute('data-hvo-val'); }
      var p1 = $('[data-hvo-p1]', el), s1 = $('[data-hvo-s1]', el), pj = $('[data-hvo-pj]', el);
      if (p1) p1.textContent = st.m1 === 'an' ? J.pan : J.p;
      if (s1) { s1.hidden = st.m1 === 'an' || !J.s; if (J.s) s1.textContent = J.s; }
      if (pj) pj.textContent = J.p;
      /* total des cadeaux affichés */
      var sum = 0; $$('.hvo-incl > [data-hvo-val]', el).forEach(function (li) { if (!li.hidden) sum += +li.getAttribute('data-hvo-val') || 0; });
      var ps = $('[data-hvo-sum]', el);
      if (ps) { ps.hidden = !(sum > 0) || !cfg.txtSum; ps.textContent = (cfg.txtSum || '').replace('[montant]', money(sum)); }
      /* choix 2 : année ou mois */
      $$('[data-hvo-mode]', el).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hvo-mode') === st.m2)); });
      $$('[data-hvo-detail]', el).forEach(function (d) { d.hidden = d.getAttribute('data-hvo-detail') !== st.m2; });
      var ap = $('[data-hvo-appprice]', el), m = cfg[st.m2];
      if (ap && m) { $('b', ap).textContent = m.p; var sm = $('small', ap); if (sm) sm.textContent = m.l; }
      if (ctaP) ctaP.textContent = prix();
      var dig = st.opt !== 'jeu';
      $$('[data-hvo-reas]', el).forEach(function (r) { r.hidden = (r.getAttribute('data-hvo-reas') === 'jeu') === dig; });
      /* dates d'expédition : seulement pour le produit physique */
      $$('[data-hvp-ship]', sec).forEach(function (s) { if (!s.closest('.hvp-guar')) s.style.display = dig ? 'none' : ''; });
      /* barre collante : prix du choix en cours */
      var slot = $('.hvp-sticky [data-hvp-price-slot]', sec);
      if (slot) { slot.innerHTML = '<span class="hv-price"><b></b></span>'; $('b', slot).textContent = prix(); }
      if (err) err.hidden = true;
      if (ferr) ferr.hidden = true;
      $$('[data-hvo-ferr2]', el).forEach(function (f) { f.hidden = true; });
      cta.disabled = st.opt === 'jeu' && J.a === false;
    }

    el.addEventListener('click', function (e) {
      var fp = e.target.closest('[data-hvo-fpick]');
      if (fp) { e.preventDefault(); var fo = fp.closest('[data-hvo-opt]'); choisirFormule(null, fo ? fo.getAttribute('data-hvo-opt') : st.opt); return; }
      if (e.target.closest('[data-hv-i]')) return;
      var b1 = e.target.closest('[data-hvo-m1]');
      if (b1) { e.preventDefault(); st.m1 = b1.getAttribute('data-hvo-m1'); st.opt = 'jeu'; rendre(); return; }
      var md = e.target.closest('[data-hvo-mode]');
      if (md) { e.preventDefault(); st.m2 = md.getAttribute('data-hvo-mode'); st.opt = 'app'; rendre(); return; }
      if (e.target.closest('select, label.hvo-sel, [data-hvo-cta], a')) return;
      var o = e.target.closest('[data-hvo-opt]');
      if (o && !o.classList.contains('is-off') && o.getAttribute('data-hvo-opt') !== st.opt) { st.opt = o.getAttribute('data-hvo-opt'); rendre(); }
    });
    el.addEventListener('change', function (e) {
      var r = e.target.closest('input[type=radio]'); if (r && !r.disabled) { st.opt = r.value; rendre(); }
      if (e.target.matches && e.target.matches('[data-hvo-formule]')) { if (ferr) ferr.hidden = true; $$('[data-hvo-ferr2]', el).forEach(function (f) { f.hidden = true; }); }
    });

    /* variante choisie sur la fiche (Carnet Qalam, kit de peinture…) */
    sec.addEventListener('hvp:variant', function (e) {
      var id = e.detail && e.detail.id, x = (cfg.variantes || []).filter(function (v) { return v.id === id; })[0];
      if (!x) return;
      J = { id: x.id, c: x.c, p: x.p, s: x.s, pan: x.pan, a: x.a };
      var vt = $('[data-hvo-vt]', el); if (vt) vt.textContent = x.t;
      var o1 = $('[data-hvo-opt="jeu"]', el);
      if (o1) { o1.classList.toggle('is-off', !x.a); var r1 = $('input[type=radio]', o1); if (r1) r1.disabled = !x.a; }
      if (!x.a && cfg.mois) st.opt = 'app';
      rendre();
    });

    /* lot d'inserts L'Archive (snippet hover-inserts-lots, 03/11/2026) : 1, 2 ou 3 inserts, prix du lot déjà remisé */
    sec.addEventListener('hvl:lot', function (e) {
      var d = e.detail || {}; if (!d.ids || !d.ids.length) return;
      J = { id: d.ids[0], ids: d.ids, c: d.c, p: money(d.c), pan: money(d.c + (cfg.an ? cfg.an.c : 0)), s: d.s ? money(d.s) : '', a: d.ok !== false };
      var vt = $('[data-hvo-vt]', el); if (vt && d.t) vt.textContent = d.t;
      rendre();
    });

    function fini() { cta.classList.remove('loading'); cta.disabled = false; ouvrirPanier(); }
    function rate() { cta.classList.remove('loading'); cta.disabled = false; if (err) err.hidden = false; }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      var items = [], code = '', fh = '', fx = [], s;
      if (st.opt === 'jeu') {
        (J.ids || [J.id]).forEach(function (id) { items.push({ id: id, quantity: 1, properties: { _hv_offre: st.m1 === 'an' ? 'produit-app-an' : 'produit-app' } }); });
        if (st.m1 === 'an' && cfg.an) {
          items.push({ id: cfg.an.id, quantity: 1, selling_plan: cfg.an.plan });
          s = sel('jeu');
          if (s && cfg.codeAn) {
            if (liste(s.value).length < NF1) { if (ferr) ferr.hidden = false; choisirFormule(function () { cta.click(); }, 'jeu'); return; }
            fh = liste(s.value).slice(0, NF); fx = liste(s.value).slice(NF, NF1); code = cfg.codeAn; /* fx : la formule du palier (formule40) */
          }
        } else {
          var A = window.HPN && HPN.enabled && HPN.app;
          if (cfg.app30 && A) {
            try { sessionStorage.removeItem('hpn-app-refus'); } catch (x) {} /* choix explicite de l'app : on oublie un « Retirer » plus ancien */
            items.push({ id: A.variant, quantity: 1, selling_plan: A.plan, properties: { _hv_cadeau: 'app30' } });
          }
        }
      } else {
        var P = cfg[st.m2]; if (!P) return;
        items.push({ id: P.id, quantity: 1, selling_plan: P.plan });
        s = sel('app');
        if (st.m2 === 'an' && s && cfg.codeAn) {
          if (liste(s.value).length < NF) { var f2 = $('[data-hvo-ferr2]', el); if (f2) f2.hidden = false; choisirFormule(function () { cta.click(); }, 'app'); return; }
          fh = liste(s.value).slice(0, NF); code = cfg.codeAn;
        }
      }
      cta.classList.add('loading'); cta.disabled = true;
      var suite = fh ? formules(fh, items) : Promise.resolve();
      if (fx.length) suite = suite.then(function () { return formules(fx, items, { _hv_cadeau: 'formule40' }); });
      suite.then(function () { return api('cart/add.js', { items: items }); })
        .then(function () { if (code) return poserCode(code); })
        .then(fini).catch(rate);
    });

    rendre();
  }

  /* ---------- coffrets (snippet hover-offre-coffrets) ---------- */
  function coffrets(box) {
    if (box._hvc) return; box._hvc = 1;
    box.addEventListener('click', function (e) {
      /* fenêtre « 🎁 » : ce qui est offert avec ce coffret */
      var gb = e.target.closest('[data-hvc-gift]');
      if (gb) { e.preventDefault(); var dl = D.getElementById(gb.getAttribute('data-hvc-gift')); if (dl) { if (dl.showModal) dl.showModal(); else dl.setAttribute('open', ''); } return; }
      var gd = e.target.closest('dialog.hvc-g');
      if (gd) { if (e.target === gd || e.target.closest('[data-hvc-gx]')) { e.preventDefault(); if (gd.close) gd.close(); else gd.removeAttribute('open'); } return; }
      var b = e.target.closest('[data-hvc-add]'); if (!b || b.disabled) return;
      e.preventDefault();
      var card = b.closest('[data-hvc]'), items = [];
      $$('[data-hvc-item]', card).forEach(function (it) {
        var s = $('select', it), id = +(s ? s.value : it.getAttribute('data-hvc-item')); /* variante choisie (ex. couleur du carnet) */
        if (id) items.push({ id: id, quantity: 1, properties: { _hv_coffret: card.getAttribute('data-hvc') } });
      });
      if (!items.length) return;
      b.classList.add('loading'); b.disabled = true;
      var er = $('[data-hvc-err]', card); if (er) er.hidden = true;
      api('cart/add.js', { items: items })
        .then(function () { b.classList.remove('loading'); b.disabled = false; ouvrirPanier(); })
        .catch(function () { b.classList.remove('loading'); b.disabled = false; if (er) er.hidden = false; });
    });
  }

  function init(c) { $$('[data-hvo]', c || D).forEach(bloc); $$('[data-hvc-box]', c || D).forEach(coffrets); }
  window.HoverOffre = { init: init };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); }); else init(D);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
